module.exports = __webpack_public_path__ + "static/media/ztyhjt.8e686888.png";